import React from "react";
import ContactPage from "../Components/Contact/ContactPage";
import Seo from "../Components/Seo/Seo";
import { useSiteSeo } from "../context/SiteSeoContext";
import { truncateMetaDescription } from "../utils/seoText";
import { usePrerenderReady } from "../utils/prerenderReady";
import { usePageSeo } from "../hooks/usePageSeo";
import { useManagedPageContent } from "../hooks/useManagedPageContent";
import BlockRenderer from "../Components/BlockRenderer/BlockRenderer";

const Contact = () => {
  const { blocks, loaded } = useManagedPageContent('contact');
  usePrerenderReady(loaded);
  const siteCtx = useSiteSeo();
  const { seo_title: pageSeoTitle, seo_description: pageSeoDesc, og_image_url: pageOgImage } = usePageSeo('contact');
  const titleSuffix =
    siteCtx.organization_name && String(siteCtx.organization_name).trim()
      ? ` | ${String(siteCtx.organization_name).trim()}`
      : " | Gem Fashion Studios";
  return (
    <>
      <Seo
        title={pageSeoTitle || `Contact Gem Fashion Studios${titleSuffix}`}
        description={pageSeoDesc || truncateMetaDescription(
          "Contact our rental boutique in Mumbai: location, phone, email, and store hours for fittings and reservations."
        )}
        canonicalPath="/contact"
        ogImage={pageOgImage || undefined}
      />
      {blocks && <BlockRenderer content={blocks} />}
      <ContactPage hideDetails={Boolean(blocks)} />
    </>
  );
};

export default Contact;
